export default "__VITE_ASSET__B3X70bqQ__"